import { Color } from '@kite-js/theme-types';

const red: Color = {
    50: '#FBE7E6',
    100: '#F9D8D8',
    200: '#E86161',
    300: '#D41300',
    400: '#B42424',
    500: '#A10000',
};

export default red;
